<template>
  <div>
    <update-payment-paypal 
      class="border-bottom py-2 mb-2"
      :paypal_info="paypal_info"
      :loaded="loaded"
      @update_paypal_info="updatePaypalInfo"
    ></update-payment-paypal>
    <validation-observer #default="{ invalid }">
      <b-form>
        <b-form-group
          label-for="is_national"
          :description= "$t('accountMx')"
        >
          <b-form-checkbox id="is_nacional" v-model="payment_data.is_national">{{$t('accountNational')}}</b-form-checkbox>
        </b-form-group>
  
        <b-form-group
          :label="$t('nameBeneficiary')"
          label-for="beneficiary_name"
        >
          <validation-provider rules="required">
            <b-form-input id="beneficiary_name" v-model="payment_data.beneficiary_name"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          :label="$t('lastNameBeneficiary')"
          label-for="beneficiary_last_name"
        >
          <validation-provider rules="required">
            <b-form-input id="beneficiary_last_name" v-model="payment_data.beneficiary_last_name"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          :label="$t('bank')"
          label-for="bank"
        >
          <validation-provider rules="required">
            <b-form-input id="bank" v-model="payment_data.bank"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          :label="getLabelClabe()"
          label-for="clabe"
        >
          <validation-provider rules="required">
            <b-form-input id="clabe" v-model="payment_data.clabe"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          :label="$t('account')"
          label-for="account"
        >
          <validation-provider rules="required">
            <b-form-input id="account" v-model="payment_data.account"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          :label="$t('email')"
          label-for="email"
        >
          <validation-provider rules="required|email" name="email" #default="{ errors }">
            <b-form-input id="email" v-model="payment_data.email"/>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
  
        <b-form-group :label="$t('telephone')">
        <validation-provider
          name="Celular"
        >
          <input-tel-brandme 
            :number_dad="payment_data.telephone"
            @number="updateTelephone"
            :key="update_telephone_component"
          ></input-tel-brandme>
        </validation-provider>
      </b-form-group>
  
        <b-form-group
          v-if="!payment_data.is_national"
          :label="$t('city')"
          label-for="city"
        >
          <validation-provider rules="required">
            <b-form-input id="city" v-model="payment_data.city"/>
          </validation-provider>
        </b-form-group>
  
        <b-form-group
          v-if="!payment_data.is_national"
          :label="$t('diecctionInternational')"
          label-for="address"
        >
          <validation-provider rules="required">
            <b-form-input id="address" v-model="payment_data.address"/>
          </validation-provider>
        </b-form-group>
  
        <div class="mt-2 text-center">
          <b-button
            variant="outline-success"
            class="w-100"
            :disabled="invalid || !state_telephone"
            @click="updatePaymentData()"
          >
            {{$t('dashboard.save')}}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormCheckbox, BFormInput, BButton } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import invitation_service from "@/services/invitation";
import { required, email } from '@validations'
import service_others from '@/services/others';
import { removeLocal, checkVerified } from '@/libs/utils/user';
import { showToast } from '@/libs/utils/others';

export default {
  name: 'paymentData',
  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BButton,
    ValidationObserver,
    ValidationProvider,
    updatePaymentPaypal: () => import('@/views/components/invitation/updatePaymentPaypal.vue'),
    InputTelBrandme: () => import('@/views/components/inputs/InputTelBrandme.vue'),
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      required,
      email,
      payment_data: {
        is_national: false,
        beneficiary_name: '',
        beneficiary_last_name: '',
        bank: '',
        clabe: '',
        account: '',
        telephone: '',
        country: '',
        city: '',
        address: '',
        email: '',
        username: this.$route.params.username,
        network: this.$route.params.network,
        slug_campaign: this.$route.params.slug
      },
      paypal_info: {},
      loaded: false,
      update_telephone_component: 0,
      state_telephone: false,
    }
  },
  created() {
    this.getProfilePayment();
  },
  computed: {
    is_payment_complete() {
      return this.isPaymentDataComplete();
    },
  },
  methods: {
    getProfilePayment() {
      service_others.getPaypalInfo()
        .then(response => {
          this.paypal_info = response;
          Object.assign(this.payment_data, response.payment_data);
          this.update_telephone_component += 1;
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
          showToast(this, 'danger', 'CoffeeIcon', 'messageAccountSettingError', 'messageAccountSettingFailed');
          removeLocal(this.$router)
        })
      this.$store.commit('appConfig/UPDATE_IS_VERIFIED', checkVerified());
    },
    isPaymentDataComplete() {
      const payment = this.payment_data;
      const requiredFields = [
        'beneficiary_name',
        'beneficiary_last_name',
        'bank',
        'clabe',
        'account',
        'email',
        'telephone',
        'country'
      ];
      if (!payment.is_national) requiredFields.push('city', 'address');

      return requiredFields.every(field => !!payment[field] && payment[field].toString().trim() !== '');
    },
    updatePaypalInfo(paypal_info) {
      this.paypal_info = paypal_info;
    },
    updateTelephone(telephone_data) {
      this.payment_data.telephone = telephone_data.number;
      this.state_telephone = telephone_data.state;
      this.payment_data.country = telephone_data.country;
    },
    getLabelClabe() {
      return this.payment_data.is_national ? 'CLABE' : 'ABBA / SWIFT / BIC'
    },
    updatePaymentData() {
      const dataToSend = { ...this.payment_data };
      if (dataToSend.is_national) {
        dataToSend.city = null;
        dataToSend.address = null;
      }

      invitation_service.updatePaymentData(dataToSend)
        .then((response) => {
          if (response.status >= 400) {
            showToast(this, 'danger', 'XCircleIcon', 'register.errorSave');
            return;
          }
          this.$emit('update_campaign_status');
          showToast(this, 'success', 'CheckCircleIcon', 'dashboard.saved');
        })
        .catch(() => {
          showToast(this, 'danger', 'XCircleIcon', 'register.errorSave');
        });
    },
  },
};
</script>

<style>
.country-selector__list {
  min-width: 300px !important;
  height: 400px !important;
  min-height: 400px;
}
.country-selector__list__item {
  display: block;
  padding: 2em 1em;
}
.dots-text {
  order: 1;
  width: 180px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
